import React from 'react';
import { useFormContext } from 'react-hook-form/dist/index.ie11';
import { CookbookInputWrapper } from 'src/components/CookbookInputWrapper/CookbookInputWrapper';

const BUSINESS_NAME_MAX_LENGTH = 50;

export interface BusinessNameControlProps {
  name: string;
  id: string;
  disabled?: boolean;
}

export function BusinessNameControl({
  name,
  id,
  disabled,
}: BusinessNameControlProps): JSX.Element {
  const { errors, control } = useFormContext();

  return (
    <CookbookInputWrapper
      name={name}
      id={id}
      control={control}
      error={errors[name]}
      inputSize="medium"
      blockWidth
      label="Business name"
      placeholder=""
      rules={{
        required: 'Business name is required',
        validate: {
          isEmpty: (value: string): boolean | string =>
            value.trim() !== '' || 'Business name must be filled out',
        },
        maxLength: {
          value: BUSINESS_NAME_MAX_LENGTH,
          message: `Business name must be ${BUSINESS_NAME_MAX_LENGTH} characters or less`,
        },
      }}
      disabled={disabled}
    />
  );
}
